
import React from "react";
import { useData } from "@/contexts/DataContext";
import MainLayout from "@/components/layouts/MainLayout";
import ScreenCard from "@/components/screens/ScreenCard";
import { Bookmark } from "lucide-react";

const FavoriteScreens = () => {
  const { getFavoriteScreens } = useData();
  const favoriteScreens = getFavoriteScreens();

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Pantallas Favoritas</h1>
          <p className="text-muted-foreground">
            Accede rápidamente a tus pantallas favoritas
          </p>
        </div>

        {favoriteScreens.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-8 text-center">
            <Bookmark className="h-16 w-16 text-muted-foreground/30 mb-4" />
            <h3 className="font-medium text-lg">No hay pantallas favoritas</h3>
            <p className="text-muted-foreground">
              Agrega pantallas a favoritos para verlas aquí
            </p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {favoriteScreens.map((screen) => (
              <ScreenCard key={screen.id} screen={screen} />
            ))}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default FavoriteScreens;
